import React, { useEffect, useState } from "react";
import { Card, CardBody, Col, Row } from "reactstrap";
import ReactApexChart from "react-apexcharts";
import axios from "axios";

const AllRegionReports = () => {
  const [regionData, setRegionData] = useState([]);
  const authUser = JSON.parse(localStorage.getItem("authUser"));
  const token = authUser?.token;
  const [LineColumnAreaData, setLineColumnAreaData] = useState({
    series: [],
    options: {},
  });

  useEffect(() => {
    fetchRegions();
  }, []);

  const fetchRegions = async () => {
    try {
      const regionResponse = await axios.get(`${process.env.REACT_APP_API_BASEURL}/region`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setRegionData(regionResponse.data);
      const productHistoryData = regionResponse.data.map(
        (region) => region.productHistory
      );

      const quarterCount = new Map();
      const quarterNames = new Set();

      productHistoryData.forEach((data, regionIndex) => {
        const regionQuarterCount = new Map();
        data.forEach((history) => {
          const quarter = history.quarter;
          const currentCount = regionQuarterCount.get(quarter) || 0;
          regionQuarterCount.set(quarter, currentCount + 1);
          quarterNames.add(quarter);
        });
        quarterCount.set(regionIndex, regionQuarterCount);
      });

      const parseQuarter = (quarter) => {
        const match = quarter.match(/Q(\d) (\d{4})/);
        if (match) {
          const [, quarterNumber, year] = match;
          return {
            quarterNumber: parseInt(quarterNumber, 10),
            year: parseInt(year, 10),
            original: quarter,
          };
        }
        return { quarterNumber: 0, year: 0, original: quarter };
      };

      const customSort = (a, b) => {
        const parsedA = parseQuarter(a);
        const parsedB = parseQuarter(b);
        if (parsedA.year === parsedB.year) {
          if (parsedA.quarterNumber === 4) return -1;
          if (parsedB.quarterNumber === 4) return 1;
          return parsedA.quarterNumber - parsedB.quarterNumber;
        } else {
          return parsedA.year - parsedB.year;
        }
      };

      const uniqueQuarterNames = Array.from(quarterNames).sort(customSort);

      if (productHistoryData.length > 0) {
        const seriesData = Array.from(quarterCount.entries()).map(
          ([regionIndex, regionQuarterCount]) => {
            const regionName = regionResponse.data[regionIndex].regionName;
            const quarterCounts = uniqueQuarterNames.map(
              (quarter) => regionQuarterCount.get(quarter) || 0
            );
            return {
              name: regionName,
              data: quarterCounts,
              quarterNames: uniqueQuarterNames,
            };
          }
        );

        setLineColumnAreaData({
          series: seriesData,
          options: {
            chart: {
              height: 350,
              type: "line",
              stacked: false,
              toolbar: {
                show: true,
                offsetX: 0,
                offsetY: 0,
                tools: {
                  download:
                    "<button type='button' style=background-color:#e42626;min-width:130px;width:max-content;border-radius:8px;padding:8px;border:none;color:white;position:fixed;top:-200%;bottom:100%;left:-600%;>Export data</button>",
                  selection: false,
                  zoom: false,
                  zoomin: false,
                  zoomout: false,
                  pan: false,
                  reset: false,
                  customIcons: [],
                },
                export: {
                  csv: {
                    filename: "RegionReportCSV",
                    columnDelimiter: ",",
                    headerCategory: "category",
                    headerValue: "value",
                    categoryFormatter(x) {
                      return new Date(x).toDateString();
                    },
                    valueFormatter(y) {
                      return y;
                    },
                  },
                  svg: {
                    filename: "RegionReportSVG",
                  },
                  png: {
                    filename: "RegionReportPNG",
                  },
                },
                autoSelected: "zoom",
              },
            },
            stroke: {
              width: [1, 1, 1],
              dashArray: [3, 0, 5],
              curve: "smooth",
            },
            legend: {
              show: true,
            },
            colors: [
              "#e42626",
              "#4E4E4e",
              "#000000",
              "#e42626",
              "#4E4E4e",
              "#000000",
            ],
            markers: {
              size: 3,
            },
            xaxis: {
              type: "Category",
              categories: uniqueQuarterNames,
              title: {
                text: "Quarters",
              },
              labels: {
                rotate: 0,
              },
            },
            yaxis: {
              title: {
                text: "Changes",
              },
            },
            tooltip: {
              shared: true,
              intersect: false,
              y: {
                formatter: function (y) {
                  if (typeof y !== "undefined") {
                    return y.toFixed(0) + " changes";
                  }
                  return y;
                },
              },
            },
            grid: {
              borderColor: "#f1f1f1",
              padding: {
                left: 40,
                right: 10,
              },
            },
          },
        });
      }
    } catch (error) {
      console.error(error);
    }
  };
  return (
    <React.Fragment>
      <Row>
        {regionData.length > 0 ? (
          <Col xl={12}>
            <Card>
              <CardBody>
                <div className="d-flex align-items-center">
                  <div className="flex-grow-1">
                    <h5 className="card-title">Region Report</h5>
                  </div>
                </div>
                <div>
                  {LineColumnAreaData.series && (
                    <ReactApexChart
                      options={LineColumnAreaData.options}
                      series={LineColumnAreaData.series}
                      type="line"
                      height="500"
                      stacked="false"
                      className="apex-charts"
                    />
                  )}
                </div>
              </CardBody>
            </Card>
          </Col>
        ) : (
          <Card>
            <CardBody>There are no regions to display.</CardBody>
          </Card>
        )}
      </Row>
    </React.Fragment>
  );
};

export default AllRegionReports;
